import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingBaterry.css';

const SettingBaterry = () => {
    const [baterry, setBaterry] = useState([]);
    const [filteredBaterry, setFilteredBaterry] = useState([]);
    const [search, setSearch] = useState("");
    const [editingBaterry, setEditingBaterry] = useState(null);
    const [newBaterry, setNewBaterry] = useState({
        name: "",
        Wh: "",
        Brand: "",
        Price: "",
        Ah: "",
        Description: "",
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchBaterry = async () => {
        const querySnapshot = await getDocs(collection(db, 'Baterias'));
        const baterrysData = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
        setBaterry(baterrysData);
        setFilteredBaterry(baterrysData);
        setLoading(false);
    };

    useEffect(() => {
        fetchBaterry();
    }, []);

    useEffect(() => {
        setFilteredBaterry(
            baterry.filter(baterry =>
                baterry.name.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, baterry]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewBaterry({
            ...newBaterry,
            [name]: value,
        });
    };

    const handleEditBattery = (baterry) => {
        setEditingBaterry(baterry);
        setNewBaterry(baterry);
    };

    const handleUpdateBattery = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas actualizar esta batería?",
            showCancelButton: true,
            confirmButtonText: "Sí, actualizar!",
            cancelButtonText: "No, cancelar",
        });

        if (result.isConfirmed) {
            try {
                await updateDoc(doc(db, 'Baterias', editingBaterry.id), newBaterry);
                Swal.fire("Actualizado", "La batería ha sido actualizado exitosamente.");
                setEditingBaterry(null);
                setNewBaterry({
                    name: "",
                    Wh: "",
                    Brand: "",
                    Price: "",
                    Ah: "",
                    Description: "",
                });
                fetchBaterry();
            } catch (error) {
                console.error("Error al actualizar la batería en la base de datos", error);
                Swal.fire("Error", "No se pudo actualizar la batería.");
            }
        }

    };

    const handleDeleteBattery = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás revertir esto!",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar!",
            cancelButtonText: "No, cancelar",
        });

        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, 'Baterias', id));
                Swal.fire("Borrado!", "La batería ha sido borrado.");
                fetchBaterry();
            } catch (error) {
                console.error("Error al eliminar la batería en la base de datos", error);
                Swal.fire("Error", "No se pudo eliminar la batería.");
            }
        }
    };
    return (
        <div className="setting-battery-container">
            <div className="title-actions">
                <h1 className="title">Gestión de Baterías</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar una batería" onClick={() => navigate('/admin/baterias')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por nombre de la batería"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="battery-list">
                    {filteredBaterry.length === 0 ? (
                        <p className="no-results">La batería que buscas no se encuentra registrado aún.</p>
                    ) : (
                        isMobile ? (
                            filteredBaterry.map(battery => (
                                <div key={battery.id} className="battery-card">
                                    {editingBaterry && editingBaterry.id === battery.id ? (
                                        <div className="edit-form">
                                            <div className="form-group">
                                                <label htmlFor="name">Nombre</label>
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    placeholder="Nombre"
                                                    value={newBaterry.name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Wh">Wh</label>
                                                <input
                                                    type="text"
                                                    id="Wh"
                                                    name="Wh"
                                                    placeholder="Wh"
                                                    value={newBaterry.Wh}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Brand">Marca</label>
                                                <input
                                                    type="text"
                                                    id="Brand"
                                                    name="Brand"
                                                    placeholder="Marca"
                                                    value={newBaterry.Brand}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Price">Precio</label>
                                                <input
                                                    type="text"
                                                    id="Price"
                                                    name="Price"
                                                    placeholder="Precio"
                                                    value={newBaterry.Price}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Ah">Ah</label>
                                                <input
                                                    type="text"
                                                    id="Ah"
                                                    name="Ah"
                                                    placeholder="Ah"
                                                    value={newBaterry.Ah}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Description">Descripción</label>
                                                <textarea
                                                    id="Description"
                                                    name="Description"
                                                    placeholder="Descripción"
                                                    value={newBaterry.Description}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="btn-form-actions">
                                                <button className="btn-ac" title="Guardar" onClick={handleUpdateBattery}><FontAwesomeIcon icon={faAdd} /></button>
                                                <button className="btn-de" title="Cancelar" onClick={() => setEditingBaterry(null)}><FontAwesomeIcon icon={faBan} /></button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="battery-info">
                                                <h3>{battery.name}</h3>
                                                <p><strong>Wh:</strong> {battery.Wh}</p>
                                                <p><strong>Marca:</strong> {battery.Brand}</p>
                                                <p><strong>Precio:</strong> {battery.Price}</p>
                                                <p><strong>Ah:</strong> {battery.Ah}</p>
                                                <p><strong>Descripción:</strong> {battery.Description}</p>
                                            </div>
                                            <div className="btn-actions">
                                                <button className="btn-ed" title="Actualizar" onClick={() => handleEditBattery(battery)}><FontAwesomeIcon icon={faRotate} /></button>
                                                <button className="btn-de" title="Eliminar" onClick={() => handleDeleteBattery(battery.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="battery-list">
                                <div className="battery-header">
                                    <span>Nombre</span>
                                    <span>Wh</span>
                                    <span>Marca</span>
                                    <span>Precio</span>
                                    <span>Ah</span>
                                    <span>Descripción</span>
                                    <span>Acciones</span>
                                </div>
                                <ul>
                                    {filteredBaterry.map(battery => (
                                        <li key={battery.id}>
                                            {editingBaterry && editingBaterry.id === battery.id ? (
                                                <div className="edit-form">
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        placeholder="Nombre de la Batería"
                                                        value={newBaterry.name}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Wh"
                                                        placeholder="Wh"
                                                        value={newBaterry.Wh}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Brand"
                                                        placeholder="Marca"
                                                        value={newBaterry.Brand}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Price"
                                                        placeholder="Precio"
                                                        value={newBaterry.Price}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="text"
                                                        name="Ah"
                                                        placeholder="Ah"
                                                        value={newBaterry.Ah}
                                                        onChange={handleInputChange}
                                                    />
                                                    <textarea
                                                        name="Description"
                                                        placeholder="Descripción"
                                                        value={newBaterry.Description}
                                                        onChange={handleInputChange}
                                                    />
                                                    <div className="btn-actions">
                                                        <button className="btn-ac" title="Guardar" onClick={handleUpdateBattery}> <FontAwesomeIcon icon={faAdd} /></button>
                                                        <button className="btn-de" title="Cancelar" onClick={() => setEditingBaterry(null)}><FontAwesomeIcon icon={faBan} /></button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span>{battery.name}</span>
                                                    <span>{battery.Wh}</span>
                                                    <span>{battery.Brand}</span>
                                                    <span>{battery.Price}</span>
                                                    <span>{battery.Ah}</span>
                                                    <span>{battery.Description}</span>
                                                    <button className="btn-ed" title="Actualizar" onClick={() => handleEditBattery(battery)}> <FontAwesomeIcon icon={faRotate} /></button>
                                                    <button className="btn-de" title="Eliminar" onClick={() => handleDeleteBattery(battery.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )
                    )}
                </div >
            )}
        </div >
    );
}

export default SettingBaterry;